<template>
	<div class="header ">
		<div class="list f-a ">
			<div class="item f-a-j pointer" :class="{active:tabs_index==index}"
			v-for="(item, index) in header" @click="to(item)">
				<div>{{ $store.state.language=='cn'?item.title:item.title_en }}</div>
			</div>
			<div class="item f-a-j pointer" 
			@click="changeLanguage">
				<div>{{ $store.state.language=='cn'?'En':'中文' }}</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			header: [
				{
					title: '首页',
					title_en:'Home',
					path:'/home'
				},
				{
					title: '产品',
					title_en:'Product',
					path: '/category'
				},
				{
					title: '品牌',
					title_en:'Brand',
					path: '/brand'
				},
				{
					title: '防伪查询',
					title_en:'Verify',
					path: '/verify'
				}
			],
			tabs_index:0
		};
	},
	watch:{
		'$route':function(val){
			this.header.forEach((item,index)=>{
				if(val.path.indexOf(item.path)>=0){
					this.tabs_index=index
				}
			})
		}
	},
	created() {
		// this._isMobile()
	},
	methods: {
		to(item) {
			
			this.$router.push({
				path: item.path
			});
		},
		changeLanguage(){
			this.$store.state.language=this.$store.state.language=='cn'?'en':'cn'
		},
		hasActive(path){
			
		}
	}
};
</script>

<style lang="less" scoped>
.header {
	position: fixed;
	top:0;
	background-color: #fff;
	width: 80vw;
	min-width: 1200px;
	margin: 0 auto;
	z-index: 9;
	padding-bottom: 2px;
	.item {
		min-width: 200px;
		height: 56px;
		border-bottom: 2px solid transparent;
	}
	.item:hover {
		background-color: #eaeaea;
	}
	.active{
		
		border-bottom-color: #eaeaea;
	}
	.list{
		width: 100%;
	}
}
</style>
